import { render } from "./InterfaceNoData.vue?vue&type=template&id=294eb479&scoped=true"
import script from "./InterfaceNoData.vue?vue&type=script&lang=js"
export * from "./InterfaceNoData.vue?vue&type=script&lang=js"

import "./InterfaceNoData.vue?vue&type=style&index=0&id=294eb479&scoped=true&lang=scss"

import exportComponent from "/tmp/4f365a42-b3f2-4061-98cc-f7413900e2b1/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-294eb479"]])

export default __exports__